var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopupActionSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4997 8.16634C22.6425 8.16634 8.16634 22.6425 8.16634 40.4997C8.16634 58.3569 22.6425 72.833 40.4997 72.833C58.3569 72.833 72.833 58.3569 72.833 40.4997C72.833 22.6425 58.3569 8.16634 40.4997 8.16634ZM0.0830078 40.4997C0.0830078 18.1782 18.1782 0.0830078 40.4997 0.0830078C62.8212 0.0830078 80.9164 18.1782 80.9164 40.4997C80.9164 62.8212 62.8212 80.9164 40.4997 80.9164C18.1782 80.9164 0.0830078 62.8212 0.0830078 40.4997ZM59.3515 27.3747C61.0198 28.8577 61.1701 31.4123 59.6871 33.0806L38.1316 57.3307C37.3646 58.1935 36.2652 58.6872 35.1108 58.6872C33.9563 58.6872 32.857 58.1935 32.09 57.3307L21.3122 45.2057C19.8293 43.5373 19.9795 40.9827 21.6479 39.4997C23.3162 38.0168 25.8708 38.167 27.3538 39.8354L35.1108 48.562L53.6456 27.7104C55.1285 26.042 57.6832 25.8918 59.3515 27.3747Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupActionSuccess);
export default __webpack_public_path__ + "static/media/popup-action-success.c07ac7440bc328c52d08803837b6718f.svg";
export { ForwardRef as ReactComponent };